<script>
    export default {
        data() {
            return {
                companies: []
            }
        },
        mounted() {
            $("#searchCompanyFormModal").on('shown.bs.modal', function() {
                $(".form-control", this).focus()
            })
        },
        methods: {
            getCompanyName(company) {
                return company.name || company.public_name
            },            
            onShowCompanyPage(company) {
                location.href = route('company.show', company.slug)
            },
            onSearchCompanies(e) {
                this.searchCompanies(this, e.target.value)
            },
            searchCompanies: _.debounce((vm, term) => {
                let url = route('companies.search')

                axios
                    .get(`${url}?term=${term}`)
                    .then(response => {
                        vm.$set(vm, 'companies', response.data.companies)
                    })
            }, 500),
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/search/SearchCompanyModal.vue